import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  container: {
    padding: theme.spacing(0, 12),
  },
  block: {
    borderRight: `1px solid ${theme.palette.background.main}`,
    height: "90%",
  },
}));
